<div class="sponsorcontainer" >
    <!-- <h1 style="text-align: center;margin-top: 90px;"><b>ΚΥΡΙΟΙ ΧΟΡΗΓΟΙ</b></h1>
    <h2 style="text-align: center;margin-top: 60px;"><b>ΧΟΡΗΓΟΙ ΣΥΝΕΔΡΙΟΥ</b></h2> -->
    <div style="width:100%;text-align:center">
        <img src="..\..\assets\sponsors.jpg" width="80%" style="max-width:800px" />
    </div>
</div>